import { MANIFESTO } from "@/data/content";
import { Reveal } from "@/components/site/Reveal";

export const Manifesto = () => (
  <section id="abordagem" className="py-24 lg:py-36">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <Reveal>
        <span className="text-xs uppercase tracking-[0.25em] text-rose-800">A minha abordagem</span>
        <h2 className="font-display font-light text-4xl sm:text-5xl lg:text-6xl text-stone-900 mt-4 max-w-2xl leading-[1.02]">
          A terapia como um caminho, feito a dois
        </h2>
      </Reveal>

      <div className="mt-16 divide-y divide-rose-100 border-t border-rose-100">
        {MANIFESTO.map((m, i) => (
          <Reveal key={m.n} delay={i * 0.06}>
            <div className="grid md:grid-cols-12 gap-6 py-10 group">
              <div className="md:col-span-2">
                <span className="font-display text-5xl text-rose-200 group-hover:text-rose-700 transition-colors duration-500">
                  {m.n}
                </span>
              </div>
              <h3 className="md:col-span-4 font-display text-2xl md:text-3xl text-stone-900">{m.title}</h3>
              <p className="md:col-span-6 text-stone-600 leading-relaxed md:text-lg">{m.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
